export default __webpack_public_path__ + "static/media/star-checked.3e570d81.svg";